import Observer from "../../classes/Observer.js";
import Dialog from "../../classes/Dialog.js";
import TokenStore from "../../classes/TokenStore.js";
import Template from "../../classes/Template.js";
import {
    empty,
    lookupOne,
    lookupOneCached,
    replaceContentsMany
} from "../../utils/elements.js";
import {
    shuffle
} from "../../utils/arrays.js";

const gameObserver = Observer.create("game");
const characterDecisionDialog = Dialog.create(lookupOne("#character-decision"));
const playerName = lookupOne("#player-name");

gameObserver.on("character-draw", ({ detail }) => {

    if (detail.isShowAll) {
        return;
    }

    const template = Template.create(
        lookupOneCached("#character-choice-template")
    );

    replaceContentsMany(
        lookupOneCached("#character-choice-wrapper"),
        shuffle(detail.characters)
            .map((character, i) => template.draw({
                "[data-id]"(element) {
                    element.dataset.id = character.getId();
                },
                ".js--character-choice--number"(element) {
                    element.textContent = i + 1;
                }
            }))
    );

    Dialog.create(lookupOneCached("#character-choice")).show();

});

gameObserver.on("character-draw", ({ detail }) => {

    if (!detail.isShowAll) {
        return;
    }

    lookupOneCached("#grimoire").open = true;

    TokenStore.ready((tokenStore) => {

        detail.characters.forEach((character) => {

            gameObserver.trigger("character-drawn", {
                character: character.clone(),
                isAutoAdd: true
            });

        });

    });

});

lookupOneCached("#character-choice").addEventListener("click", ({ target }) => {

    const element = target.closest("[data-id]");

    if (!element || element.disabled) {
        return;
    }

    // Trigger a character choice click event that can be intercepted by secret assignment
    gameObserver.trigger("character-choice-click", {
        element,
        characterId: element.dataset.id
    });

});

// Fallback handler for when secret assignment is not active
gameObserver.on("character-choice-click", ({ detail }) => {
    // If no secret assignment handler has processed this event, handle it normally
    if (!detail.processed) {
        // Check if secret assignment is active and has a selected character
        // We need to access the secret assignment state from the global scope
        if (window.secretAssignmentState && 
            window.secretAssignmentState.isEnabled && 
            window.secretAssignmentState.selectedCharacter) {
            console.log("Secret assignment is active, skipping fallback handler");
            return;
        }
        
        TokenStore.ready((tokenStore) => {
            // Add a clone of the character so that duplicated characters are still
            // considered unique.
            const character = tokenStore.getCharacter(detail.characterId);
            console.log("Fallback handler triggered, giving character:", character.getName());
            gameObserver.trigger("character-drawn", {
                element: detail.element,
                character: character.clone()
            });
        });
    }
});

gameObserver.on("character-drawn", ({ detail }) => {

    const {
        element
    } = detail;

    // Don't disable the element if secret assignment is active AND we're in overlay mode
    // (but do disable it when player is seeing numbers)
    if (element && (!window.secretAssignmentState || 
                   !window.secretAssignmentState.isEnabled || 
                   !window.secretAssignmentState.isOverlayMode)) {
        element.disabled = true;
    }

});

gameObserver.on("character-drawn", ({ detail }) => {

    const {
        isAutoAdd,
        character
    } = detail;

    if (isAutoAdd) {
        return;
    }

    empty(lookupOneCached("#character-decision-wrapper")).append(
        character.drawToken()
    );
    lookupOneCached("#character-decision-ability").textContent = (
        character.getAbility()
    );
    characterDecisionDialog.show();

});

// Allow a name to be set when the character is revealed.
// We do this by checking to see if a name was entered when the "remember your
// character" dialog is closed, using it if it was.

let character = null;

gameObserver.on("character-drawn", ({ detail }) => {
    character = detail.character;
});

characterDecisionDialog.on(Dialog.SHOW, () => {
    playerName.value = playerName.defaultValue;
});

characterDecisionDialog.on(Dialog.HIDE, () => {

    const {
        pad
    } = lookupOneCached(".js--pad");
    const {
        value
    } = playerName;
    const trimmed = (value || "").trim();

    if (pad && trimmed && character) {
        pad.setPlayerName(character, trimmed);
    }

    character = null;

});

lookupOne("#character-decision-form").addEventListener("submit", (e) => {
    e.preventDefault();
    characterDecisionDialog.hide();
});
